<template>
  <div class="milestones">
    <div class="milestones__circles">
      <div
        class="milestones__circles__circle"
        v-for="milestoneData in filteredYears"
        :key="milestoneData.index"
        :style="[
          {
            top: `calc(${100 / (years.length - 1)}% * ${milestoneData.index})`,
            background:
              milestoneData.index == 6 && filteredYears.length > 1
                ? '#f5f5f5'
                : 'var(--white-100)',
          },
        ]"
      >
        <div
          :class="[
            'milestones__circles__circle__label',
            { small: milestoneData.label.includes('<div>') },
          ]"
          v-if="milestoneData.label && !Array.isArray(milestoneData.label)"
          v-html="
            milestoneData.label +
            (milestoneData.unit ? ' ' + milestoneData.unit : '')
          "
        />

        <div
          class="milestones__circles__circle__label"
          v-else-if="
            milestoneData.label && !!Array.isArray(milestoneData.label)
          "
        >
          <p
            v-for="(paragraph, index) in milestoneData.label"
            :key="'paragraph' + index"
          >
            {{ paragraph }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="milestones__line"
      :style="{
        height: `calc(100% - ${
          100 - (100 / years.length * (years.length - filteredYears[filteredYears.length - 1].index))
        }% - 2.3rem)`,
      }"
    ></div>
    <div class="milestones__step-label" v-html="area.label" />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  area: {
    type: Object,
    required: true,
  },
  years: Array,
  isLastOne: Boolean,
});

const filteredYears = computed(() => {
  const filteredArray = [];

  const yearsArray = props.years;
  props.area.milestones.map((el) => {
    filteredArray.push({
      index: yearsArray.indexOf(el.year),
      label: el.label,
      unit: props.area.unit,
    });
  });

  return filteredArray;
});
</script>

<style lang="scss" scoped>
.milestones {
  height: 100%;
  width: calc(10rem + 27px);
  position: relative;
  z-index: 1;
  padding-right: 5rem;

  &__circles {
    position: absolute;
    height: calc(100% - 27px);
    bottom: 0;

    &__circle {
      position: absolute;
      width: 10px;
      height: 10px;
      bottom: 0;
      transform: translate(-35%, -50%);
      border-radius: 100px;
      // box-shadow: 0px 0px 16px var(--white-100);

      &__label {
        @include p-s;

        color: var(--black-100);
        position: relative;
        transform: translate(1.1rem, calc(-50% - 10px));
        background: var(--scala-grigi-gray-5);
        padding: toRem(5) toRem(10);
        width: max-content;

        font-size: toRem(15);
        line-height: 1.3;

        
        &.small ::v-deep(div) {
          font-size: toRem(14);
          line-height: 130%;
        }
      }
    }
  }
  &__line {
    width: 1px;
    position: absolute;
    z-index: -1;
    bottom: 0;
    // box-shadow: 0px 0px 16px var(--primary-yellow);
    background: var(--white-100);
  }
  &__step-label {
    @include p-s;
    position: absolute;
    width: 90%;
    bottom: 0;
    transform: translate(-10%, calc(100% + 28px));
    color: var(--scala-grigi-gray-5);
  }
}
</style>
